module.exports = __webpack_public_path__ + "static/media/computer.6cea2835.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/computer.svg
// module id = 208
// module chunks = 21